<template>
    <div>
        <v-inline-loader v-if="isLoading && !renderModal"/>
        <r-button v-if="!renderModal" type="link" @click="openDocument">{{ placeholder }}</r-button>
        <review-document-modal
            v-if="renderModal"
            :is-init-modal-visible="true"
            :button-label="placeholder"
            :document="model"
            v-on:reject="rejectDocument"
            v-on:accept="acceptDocument"
            @close="hideDocument"/>
    </div>
</template>
<script>
    import KYCDocumentModel from '@/common/models/kyc-document-model';
    import ReviewDocumentModal from '@/components/kyc/review-document-modal';
    import vInlineLoader from '@/components/v-inline-loader';
    import AsyncMessageDetailsMixin from '../messages/async-message-details-mixin';

    export default {
        name: 'kyc-link-summary',
        components: {
            ReviewDocumentModal,
            vInlineLoader,
        },
        mixins: [
            new AsyncMessageDetailsMixin({
                Model: KYCDocumentModel,
                fetchOnInit: false,
            }).getMixin(),
        ],
        props: {
            placeholder: {
                type: String,
                required: true,
            },
        },
        computed: {
            renderModal() {
                return this.showDocument && this.model.id !== null;
            },
        },
        data() {
            return {
                showDocument: false,
            };
        },
        methods: {
            getDelegate(callback) {
                return this.$api(({kycDocuments}) => callback(kycDocuments));
            },
            async review(action, params) {
                this.isLoading = true;
                this.serverError = false;
                try {
                    const {fields} = await this.$api(
                        ({kycDocuments}) => kycDocuments[action](params),
                    );
                    this.model = new KYCDocumentModel(fields);
                    this.$toast.positive(`Document successfully ${action}ed`);
                    this.$emit('updated');
                    this.isLoading = false;
                } catch (error) {
                    this.$toast.negative(`Document could not be ${action}ed`);
                    this.isLoading = false;
                    this.serverError = error;
                }
            },
            acceptDocument({id}) {
                this.review('accept', {id});
            },
            rejectDocument({id}, {type, message}) {
                this.review('reject', {id, data: {type, message}});
            },
            hideDocument() {
                this.showDocument = false;
            },
            openDocument() {
                this.showDocument = true;
                this.fetchData();
            },
        },
    };
</script>
